/*
 * Copyright (c) 2020. American Express Company
 */

import _ from 'lodash';
import queryString from 'query-string';

export default class SubRouteService {
    public static hasJWT(): boolean {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams) {
            const jwt: string = urlParams.get('JWT') || urlParams.get('jwt');
            return !!jwt;
        }
        return false;
    }

    public static readonly CURRENCY_PARAMS = [
        'monthly_income',
        'annual_income',
        'income',
        'monthly_home_expense',
        'annual_home_expense',
        'expenses',
        'home_savings_investment',
        'investments',
        'debt',
        'debts'
    ];

    private static convertCurrencies(params: any): Object {
        _.forEach(params, (param: any, key: string) => {
            if (_.includes(this.CURRENCY_PARAMS, key)) {
                params[key] = Number(param.replace(/(\$|,)/g, ''));
            }
        });

        return params;
    }

    /**
     * Gets an object with all the URL params, based on a stringed URI
     * @param urlParams
     */
    public static parseQuery(urlParams: string): Object {
        return this.convertCurrencies(queryString.parse(urlParams));
    }

    /**
     * Creates a URI string from an object of URL params
     * @param urlParams
     */
    public static stringifyQuery(urlParams: Object): string {
        return queryString.stringify(urlParams);
    }

    /**
     * Returns a new complete list of params, updating as specified
     * @param props
     * @param newParams
     */
    public static replaceParams(props: any, newParams: Object): Object {
        const params = this.parseQuery(props.location.hash || props.location.search);
        return { ...params, ...newParams };
    }

    /**
     * Useful for updating Board state based on URL params, as needed
     * @param currentProps
     * @param prevProps
     */
    public static getBoardRoute(currentProps: any, prevProps: any): Object {
        if (currentProps.location === prevProps.location) return;
        return this.parseQuery(currentProps.location.search || currentProps.location.hash);
    }
}
